import * as budgetsActions from '../actions/Budgets';

const initialState = {
  list: [],
  offset: 0,
  limit: 10,
  count: 7,
  error: false,
  status: 200,
  error_message: ''
};

const budgets = (state = initialState, action) => {
  switch (action.type) {
    case budgetsActions.GET_BUDGETS_SUCCESS:
      return Object.assign({}, state, { list: action.payload });
    case budgetsActions.GET_BUDGETS_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default budgets;
